//React lib
import { Box, IconButton, Modal } from "@mui/material";
//Third party lib
import { useTranslation } from "react-i18next";
//Internal lib
import "./Modal.scss";
import ActionButton from "./ActionButton";
import FeedbackLegent from "../portal/sendNotification/feedbackLegent";
//Icon
import CancelIcon from "@mui/icons-material/Cancel";

export interface ModalProp {
  state: boolean;
  onClose: any;
  title: string;
  content: React.ReactNode;
  size: string;
  subTitle?: any;
  note?: any;
  actionBtn?: boolean;
  screenName?: string;
  closeButtonHide?: boolean | undefined;
  backdrop?: boolean;
}

const ModalDialog: React.FC<ModalProp> = (props: any) => {
  const { onClose, backdrop } = props;
  const { t } = useTranslation();

  return (
    <Modal
      open={props.state}
      onClose={backdrop === false ? undefined : onClose || undefined}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className={
          "modal-container " +
          (props.size === "l"
            ? "large"
            : props.size === "m"
            ? "medium"
            : props.size === "mn"
            ? "medium-narrow"
            : "small")
        }
      >
        <div className="title border-down">
          <div className={"full "}>
            <div
              className={
                props.screenName === "dashboard" ? "modal-title-container" : ""
              }
            >
              <span className="font-18 bolder">{props.title}</span>
              {props.screenName === "dashboard" && (
                <FeedbackLegent></FeedbackLegent>
              )}

              {props.subTitle ? (
                <div className="margin-up-10">
                  <span className="font-12 color-sec margin-right-10">
                    {" "}
                    {props.note}
                  </span>
                  <span className="small-f">{props.subTitle}</span>
                </div>
              ) : (
                ""
              )}
              <span></span>
            </div>
          </div>
          {!props.closeButtonHide && (
            <div className="center">
              <IconButton onClick={props.onClose} className="close-icon">
                <CancelIcon />
              </IconButton>
            </div>
          )}
        </div>
        <div className={props.size !== "s" ? "modal-content" : ""}>
          {props.content}
          {props.actionBtn ? (
            <div className="center-end flex-gap  padding-y-10 border-top margin-up-20 margin-down-10">
              <ActionButton
                actionButtonStyle="outline"
                label={t("clear")}
                onClick={props.onClose}
              ></ActionButton>
              <ActionButton label={t("submit")}></ActionButton>
            </div>
          ) : (
            ""
          )}
        </div>
      </Box>
    </Modal>
  );
};
export default ModalDialog;
